import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartBounce, setCartBounce] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('user');
    // 整頁重新載入，確保所有依賴登入狀態的畫面（Header、首頁閘門等）一併重置
    window.location.href = '/';
  };

  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const totalCount = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
    const previousCount = cartCount;
    setCartCount(totalCount);

    if (totalCount > previousCount) {
      setCartBounce(true);
      setTimeout(() => setCartBounce(false), 500);
    }
  };

  useEffect(() => {
    updateCartCount();

    // Listen for storage changes
    const handleStorageChange = () => {
      updateCartCount();
    };

    window.addEventListener('storage', handleStorageChange);

    // Custom event for cart updates in the same window
    const handleCartUpdate = () => {
      updateCartCount();
    };
    window.addEventListener('cartUpdated', handleCartUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [cartCount]);

  const currentUser = JSON.parse(localStorage.getItem('user') || 'null');

  return (
    <header className="header">
      <div className="container">
        <div className="header-left">
          <Link to="/" className="logo">
            <img src="/nkd-logo.png" alt="NKD" className="logo-img" />
          </Link>

          <nav className="nav-left desktop-nav">
            <Link to="/" className="nav-link">首頁</Link>
            <Link to="/contact" className="nav-link">聯絡我們</Link>
          </nav>
        </div>

        <nav className="nav-right desktop-nav">
          {currentUser ? (
            <div className="user-dropdown">
              <button className="user-dropdown-toggle">
                歡迎, {currentUser.username}
              </button>
              <div className="dropdown-menu">
                <Link to="/my-orders" className="dropdown-item">
                  我的訂單
                </Link>
                <Link to="/profile" className="dropdown-item">
                  個人資料設定
                </Link>
                <Link to="/change-password" className="dropdown-item">
                  修改密碼
                </Link>
                {currentUser.isAdmin && (
                  <Link to="/admin" className="dropdown-item">
                    後台管理
                  </Link>
                )}
                <button onClick={handleLogout} className="dropdown-item">
                  登出
                </button>
              </div>
            </div>
          ) : (
            <>
              <Link to="/login" className="nav-link">登入</Link>
            </>
          )}
          {currentUser && (
            <Link to="/cart" className="nav-link cart-link">
              購物車
              {cartCount > 0 && (
                <span className={`cart-badge ${cartBounce ? 'bounce' : ''}`}>
                  {cartCount}
                </span>
              )}
            </Link>
          )}
        </nav>

        {/* Mobile Navigation */}
        <div className="mobile-nav">
          {currentUser && (
            <Link to="/cart" className="nav-link cart-link">
              購物車
              {cartCount > 0 && (
                <span className={`cart-badge ${cartBounce ? 'bounce' : ''}`}>
                  {cartCount}
                </span>
              )}
            </Link>
          )}
          <button
            className={`hamburger-btn ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <Link to="/" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
              首頁
            </Link>
            <Link to="/contact" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
              聯絡我們
            </Link>
            {currentUser ? (
              <>
                <Link to="/my-orders" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
                  我的訂單
                </Link>
                <Link to="/profile" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
                  個人資料設定
                </Link>
                <Link to="/change-password" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
                  修改密碼
                </Link>
                {currentUser.isAdmin && (
                  <Link to="/admin" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
                    後台管理
                  </Link>
                )}
                <button onClick={handleLogout} className="mobile-menu-item">
                  登出
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>
                  登入
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;